import { API_ROOT } from "config.js";

const GOAL_LIST_ENDPOINT = `${API_ROOT}/api/goals/`;

export async function getGoals(axios, includeDetails = false) {
  const response = await axios.get(
    `${GOAL_LIST_ENDPOINT}?include_details=${includeDetails}`
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getGoalDetails(axios, goalId) {
  const response = await axios.get(
    `${GOAL_LIST_ENDPOINT}${goalId}/?include_details=true`
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getGoalMilestones(axios, goalId) {
  const response = await axios.get(
    `${GOAL_LIST_ENDPOINT}${goalId}/milestones/`
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getGoalTasks(axios, goalId) {
  const response = await axios.get(`${GOAL_LIST_ENDPOINT}${goalId}/tasks/`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function addGoalMilestones(axios, goalId, milestoneData) {
  const response = await axios.post(
    `${GOAL_LIST_ENDPOINT}${goalId}/milestones/`,
    milestoneData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function deleteGoalMilestones(axios, goalId, milestoneId) {
  const response = await axios.delete(
    `${GOAL_LIST_ENDPOINT}${goalId}/milestones/${milestoneId}/`
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function addGoalTasks(axios, goalId, milestoneId, taskData) {
  const response = await axios.post(
    `${GOAL_LIST_ENDPOINT}${goalId}/milestones/${milestoneId}/tasks/`,
    taskData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function deleteGoalTasks(axios, goalId, milestoneId, taskId) {
  const response = await axios.delete(
    `${GOAL_LIST_ENDPOINT}${goalId}/milestones/${milestoneId}/tasks/${taskId}/`
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}
